import React, { useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import * as XLSX from 'xlsx';

const ExportarExcel = ({ quejas, filtradas }) => {
  const [exportando, setExportando] = useState(false);

  const formatearFechaExcel = (fecha) => {
    if (!fecha) return 'N/A';
    const d = new Date(fecha);
    return d.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const obtenerTextoEstado = (estado) => {
    switch (estado) {
      case 'pendiente':
        return 'Pendiente';
      case 'en_proceso':
        return 'En Proceso';
      case 'resuelta':
        return 'Terminada';
      default:
        return estado || 'N/A';
    }
  };

  const obtenerTextoTipo = (tipo) => {
    if (!tipo) return 'N/A';
    return tipo === 'anonima' ? 'Anónima' : 'Identificada';
  };

  const exportarAExcel = () => {
    if (filtradas.length === 0) {
      alert('No hay datos para exportar');
      return;
    }

    setExportando(true);

    // Delay mínimo para que el spinner sea visible
    setTimeout(() => {
      const datosExportar = filtradas.map((queja, index) => ({
        'N°': index + 1,
        'ID': queja.id || 'N/A',
        'Fecha de Creación': formatearFechaExcel(queja.fecha_creacion),
        'Fecha de Finalización': formatearFechaExcel(queja.fecha_actualizacion),
        'Tipo de Sugerencia': obtenerTextoTipo(queja.tipo_queja),
        'Nombre':
          queja.nombre ||
          (queja.tipo_queja === 'anonima' ? 'Anónimo' : 'N/A'),
        'Correo Electrónico': queja.correo || 'N/A',
        'Proyecto': queja.proyecto || 'N/A',
        'Cargo': queja.cargo || 'N/A',
        'Estado': obtenerTextoEstado(queja.estado),
        'Descripción': queja.queja_preview || 'N/A',
        'Tiene Evidencia': queja.evidencia_filename ? 'Sí' : 'No'
      }));

      const ws = XLSX.utils.json_to_sheet(datosExportar);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sugerencias');

      const fecha = new Date().toISOString().split('T')[0];
      const nombreArchivo = `sugerencia_${fecha}.xlsx`;

      XLSX.writeFile(wb, nombreArchivo);

      setExportando(false);
    }, 400);
  };

  return (
    <Button
      variant="success"
      onClick={exportarAExcel}
      className="ms-2"
      disabled={exportando}
    >
      {exportando ? (
        <>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="me-2"
          />
          Exportando...
        </>
      ) : (
        <>
          <i className="bi bi-file-earmark-excel me-2"></i>
          Exportar Excel
        </>
      )}
    </Button>
  );
};

export default ExportarExcel;
